<script lang="ts" setup>
import TripMonitorSearchForm from "@/views/trips/monitor/components/TripMonitorSearchForm.vue";
import TripsList from "@/views/trips/monitor/components/TripsList.vue";
import { onMounted, onUnmounted, ref } from "vue";
import type { TripMonitorSearchParams } from "@/api/trips/dto/trip-monitor";
import { useBaseView } from "@/composables";

const { setTitle } = useBaseView();

const searchParams = ref<TripMonitorSearchParams | null>(null);
const isFilterVisible = ref<boolean>(true);
const searchFormHeight = ref<number>(0);

function search(params: TripMonitorSearchParams) {
  searchParams.value = { ...params };
}

onMounted(() => {
  setTitle("Trip Monitor", null, true);
});

onUnmounted(() => {
  setTitle("");
});
</script>

<template>
  <v-container class="pa-6 pb-0 height-100 trip-monitor" fluid>
    <transition name="slide-filters">
      <trip-monitor-search-form
        v-show="isFilterVisible"
        v-model:height="searchFormHeight"
        :visible="isFilterVisible"
        @search="search"
      />
    </transition>

    <trips-list :search-params="searchParams" />
  </v-container>
</template>

<style lang="scss" scoped>
.slide-filters-enter-active,
.slide-filters-leave-active {
  transition:
    transform 0.5s ease,
    opacity 0.5s ease;
}

.slide-filters-enter-from,
.slide-filters-leave-to {
  transform: translateY(-100%);
  opacity: 0;
}

.trip-monitor {
  &:deep(.v-btn__content) {
    text-transform: capitalize;
  }
}
</style>
